import * as React from 'react'
import { FC } from 'react'
import {
  IDiscountLineItem,
  ReferralTypes,
} from '@user/store/discountCode/typings'
import {
  SimpleAccordion,
  SimpleAccordionDetails,
  SimpleAccordionSummary,
} from '@sales-center/components'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { DiscountLineItemCard } from './DiscountLineItemCard/DiscountLineItemCard'
import { getStyles } from './styling'
import { discountAmountString } from './discountAmountString'
import { useTheme } from '@mui/material/styles'

interface Props {
  discountLineItem: IDiscountLineItem
}

export const DiscountLineItemWrapper: FC<Props> = (props) => {
  const { discountLineItem } = props

  const title = `${discountLineItem.services.length} Service${
    discountLineItem.services.length === 1 ? '' : 's'
  } (${
    discountLineItem.referralType === ReferralTypes.Existing
      ? 'Existing'
      : 'New'
  } Customer Discount) Selected at ${discountAmountString(
    discountLineItem.amount,
    discountLineItem.amountType,
  )} Off`
  const styles = getStyles(useTheme())
  return (
    <SimpleAccordion
      sx={styles.accordionContainer}
      square
      defaultExpanded={true}
    >
      <SimpleAccordionSummary
        sx={styles.accordionSummary}
        expandIcon={<ExpandMoreIcon />}
      >
        <span style={styles.accordionTitle}>{title}</span>
      </SimpleAccordionSummary>
      <SimpleAccordionDetails sx={styles.accordionDetails}>
        <DiscountLineItemCard discountLineItem={discountLineItem} />
      </SimpleAccordionDetails>
    </SimpleAccordion>
  )
}
